<template>
  <!-- outNight   昼伏夜出-->
  <el-container class="outNight">
    <el-card class="tabs-card">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <el-form-item label="姓名">
          <el-autocomplete
            v-model="tableParams.personName"
            :fetch-suggestions="searchAsync"
            @select="handleSelect"
            placeholder=""
            clearable
          >
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="证件号码">
          <el-input
            placeholder="证件号码"
            v-model="tableParams.cardNumber"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="人员库">
          <el-select
            v-model="tableParams.libraryId"
            clearable
            placeholder="请选择人员库"
          >
            <el-option
              v-for="it in carList"
              @click="btnClick(item, index, it)"
              :key="it.createId"
              :label="it.libraryName"
              :value="it.libraryId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分析时段">
          <h-date-timerange
            v-model:end="tableParams.endTime"
            v-model:start="tableParams.beginTime"
          >
          </h-date-timerange>
        </el-form-item>
        <el-form-item label="抓拍卡口">
          <h-button @click="allClick" v-if="currentEquipment.length == 0"
            >全部设备</h-button
          >
          <h-button @click="allClick" v-else
            >已选择{{ currentEquipment.length }}台</h-button
          >
        </el-form-item>
        <el-form-item>
          <h-button @click="clicksetup">设置</h-button>
          <h-button type="primary" v-debounce="handleAnalysis">分析</h-button>
          <!-- <h-button>导出</h-button> -->
        </el-form-item>
      </el-form>

      <div class="centerBox" v-if="resultData.length !== 0">
        <div
          class="centerList"
          v-for="(item, index) in resultData"
          :key="index"
        >
          <div class="centerImg" @click="lookFrequentHaunt(item)">
            <img v-if="item.imagePartUrl" :src="item.imagePartUrl" />
            <img v-else src="~@/assets/images/moren.png" alt="" />
          </div>
          <div class="centerTitle">
            <div class="location text-ellipsis">
              {{ item.deviceName }}
            </div>
            <div class="count">
              <p>昼出：{{ item.dayOutCount ? item.dayOutCount : 0 }}次</p>
              <p>夜出：{{ item.nightOutCount ? item.nightOutCount : 0 }}次</p>
            </div>
          </div>
        </div>
      </div>
      <el-empty v-else class="emptyDom"></el-empty>
      <div class="pagination">
        <el-pagination
          v-model:currentPage="currentPage"
          v-model:page-size="tableParams.pageSize"
          :page-sizes="[35, 50, 100, 200]"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </el-card>
    <personTransferApplication
      @transferApplicationList="getTransferList"
      v-model:visible="moveVisible"
      v-show="moveVisible"
    ></personTransferApplication>
    <el-dialog v-model="setupVisible" title="规则设置" width="40%">
      <outSetup
        @getParams="getParams"
        @closeDialog="setupVisible = false"
      ></outSetup>
    </el-dialog>
    <outSetup v-show="false" @getParams="getParams"></outSetup>
    <el-dialog v-model="tableVisible" title="昼伏夜出详情" width="60%">
      <outDetial
        v-model:params="detialsParams"
        :colorDict="colorDict"
      ></outDetial>
    </el-dialog>
    <carArchivesDialog
      v-if="carArchivesVisible"
      v-model:visible="carArchivesVisible"
      :itemInfo="carArchivesItem"
    ></carArchivesDialog>
  </el-container>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  ref,
  nextTick,
} from "vue";
import moment from "moment";
import {
  facecrouchKey,
  libraryList,
} from "@/api/publicSecurityResearch/keyCarPerson.js";
import { getDict } from "@/api/constant";
import { queryUserList } from "@/api/realPopulation/realPopulation";
import outSetup from "./components/outSetup";
import outDetial from "./components/outDetial";
import personTransferApplication from "../components/personTransferApplication";
import { ElMessage } from "element-plus";

export default defineComponent({
  name: "outNight",
  components: {
    outSetup,
    outDetial,
    personTransferApplication,
  },
  props: {},
  setup(props) {
    const data = reactive({
      tableParams: {
        personName: "",
        cardNumber: "",
        beginTime: moment(new Date().getTime() - 3600 * 1000 * 24 * 7).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        endTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        libraryId: "",
        deviceIds: [],
        pageSize: 35,
        pageNum: 1,
      },
      total: 0,
      setParams: {
        beginGfsf: "06:00",
        endGfsf: "18:00",
        minCarCount: 10,
      },
      resultData: [],
      carList: [],
      moveVisible: false,
      setupVisible: false,
      transferKeys: [9],
      treeOrganPerson: [],
      rootNodeKey: "",
      currentPage: "",
      currentEquipment: [],
      tableVisible: false,
      detialsParams: {},
      carPeerDetailParams: null,
      carArchivesVisible: false, //一车一档弹框
      carArchivesItem: null, //一车一档数据
      colorDict: [],
      timeOut: null,
      personImageUrl: "",
    });
    const refData = toRefs(data);
    const tableRef = ref();

    //获取重点车辆库
    const getBaseList = async (val) => {
      const params = {
        libraryFlag: "1",
        isPage: false,
      };
      const res = await libraryList(params);
      if (res.code == 0) {
        data.carList = res.page.list;
      }
    };
    getBaseList();
    //设置按钮框参数
    const getParams = (val) => {
      data.setParams = val;
    };
    // 获取数据字典
    const queryMenuType = async () => {
      const resCarColor = await getDict("car_card_color");
      nextTick(() => {
        data.colorDict = resCarColor.dict;
      });
    };
    queryMenuType();
    // 获取结构树
    const searchAsync = async (queyString, cb) => {
      if (!data.tableParams.personName) return;
      data.personImageUrl = "";
      data.tableParams.cardNumber = "";
      const form = {
        name: data.tableParams.personName,
        regionId: 1,
        isPage: false,
      };
      clearTimeout(data.timeOut);

      data.timeOut = setTimeout(async () => {
        const res = await queryUserList(form);
        if (res.code == 0) {
          res.page.list.forEach((element) => {
            element.value = element.name + "  " + element.cardNumber;
          });
          cb(res.page.list);
        }
      }, 1500);
    };
    // 点击结构树
    const handleSelect = async (item) => {
      data.tableParams.personName = item.name;
      data.tableParams.cardNumber = item.cardNumber;
      data.personImageUrl = item.imageUrl;
    };
    //查询昼伏夜出列表
    const handleAnalysis = async () => {
      const form = _.cloneDeep({ ...data.setParams, ...data.tableParams });
      const res = await facecrouchKey(form, {
        loading: true,
        loadingDom: ".emptyDom",
      });
      data.total = res.page.totalCount;
      data.resultData = res.page.list;
    };
    //获取穿梭框数据
    const getTransferList = (val) => {
      data.tableParams.deviceIds = [];
      data.moveVisible = false;
      data.currentEquipment = val;
      data.currentEquipment.forEach((item) => {
        data.tableParams.deviceIds.push(item.tollgateId);
      });
    };
    const allClick = () => {
      data.moveVisible = true;
    };
    const clicksetup = () => {
      data.setupVisible = true;
      console.log(data.setupVisible);
    };
    //查看频繁出没详情
    const lookFrequentHaunt = (value) => {
      data.detialsParams = {
        ...data.tableParams,
        ...data.setParams,
      };
      data.detialsParams.faceId = value.faceId;
      data.tableVisible = true;
    };

    // 改变页数
    const handleCurrentChange = (val) => {
      data.tableParams.pageNum = val;
      handleAnalysis();
    };
    // 翻页
    const handleSizeChange = (val) => {
      data.tableParams.pageSize = val;
      handleAnalysis();
    };
    return {
      ...refData,
      tableRef,
      allClick,
      queryUserList,
      clicksetup,
      handleAnalysis,
      getTransferList,
      getParams,
      lookFrequentHaunt,
      handleCurrentChange,
      handleSizeChange,
      searchAsync,
      handleSelect,
    };
  },
});
</script>
<style lang="scss" scoped>
.outNight {
  width: 100%;
  height: 100%;
  .tabs-card {
    flex: 1;
    .centerBox {
      width: 100%;
      height: 90%;
      display: grid;
      grid-template-columns: repeat(auto-fill, 240px);
      grid-gap: 11px 24px;
      justify-content: space-around;
      overflow: auto;
      .centerList {
        width: 240px;
        height: 235px;
        display: inline-block;
        margin: 10px 25px 25px 0;
        cursor: pointer;
        border-radius: 10px;
        background-color: #fff;
        box-shadow: var(--el-box-shadow-light);
        overflow: hidden;
        padding: 10px 15px;
        cursor: pointer;
        .centerTitle {
          @include flex-col-sb-c;
          height: 50px;
          text-align: center;
          display: flex;
          align-items: center;
          font-size: 14px;
          .location {
            width: 100%;
            height: 20px;
          }
          .count {
            width: 100%;
            display: flex;
            justify-content: space-between;
          }
          .carBtn {
            background: #36c13c;
            width: 100px;
            height: 30px;
            line-height: 30px;
            border-radius: 4px;
            margin: 0 5px;
          }
        }
        .centerImg {
          height: 80%;
          display: flex;
          justify-content: center;
          img {
            width: 192px;
            max-height: 178px;
            border-radius: 4px 4px 0 0;
          }
        }
      }
    }
    .pagination {
      margin-top: 15px;
    }
  }
  .organTransfer {
    height: 60vh;
  }
}
</style>
